export const getLeaveApplicationList = state => {
    return state.list
}

export const getLeaveApplicationDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveApplication/getters.js